"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var stompjs_1 = require("@stomp/stompjs");
var bid_management_service_1 = require("./service/bid-management.service");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var operators_1 = require("rxjs/operators");
var SockJS = require("sockjs-client");
var BidManagementComponent = /** @class */ (function () {
    function BidManagementComponent(bidManagementService, cookieService, applicationPropertiesService) {
        this.bidManagementService = bidManagementService;
        this.cookieService = cookieService;
        this.applicationPropertiesService = applicationPropertiesService;
        this.onConnectionStatusChange = new core_1.EventEmitter();
        this.CMS_SERVICE_URL_KEY = 'cms-service-url';
        this._destroy$ = new Subject_1.Subject();
    }
    BidManagementComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._loadTopBidByLotId$ = this.bidManagementService.loadTopBidByLotId(this.lotId);
        this.applicationPropertiesService.getProperty(this.CMS_SERVICE_URL_KEY).then(function (url) {
            _this._serviceUrl = url;
            _this.connect();
        });
    };
    BidManagementComponent.prototype.ngOnDestroy = function () {
        this.disconnect();
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    BidManagementComponent.prototype.connect = function () {
        this._stompClient = new stompjs_1.Client({
            debug: this.outputStompDebug ? function (msg) {
                console.log(msg);
            } : function () { }
        });
        this._stompClient.reconnectDelay = 5000;
        this.configStompClient();
        this._stompClient.activate();
    };
    BidManagementComponent.prototype.disconnect = function () {
        var _this = this;
        if (this._stompClient) {
            this._stompClient.deactivate().then(function () {
                _this.connectedStatusChangeHandler(false);
            });
        }
    };
    BidManagementComponent.prototype.placeBid = function () {
        var _this = this;
        if (this.container && this.container.beforePlacingBidHandler) {
            this.container.beforePlacingBidHandler().pipe(operators_1.take(1))
                .subscribe(function (proceed) {
                if (proceed) {
                    _this.sendBid();
                    _this.callContainerFunction('afterPlacingBidHandler', null);
                }
            });
        }
        else {
            this.sendBid();
            this.callContainerFunction('afterPlacingBidHandler', null);
        }
    };
    BidManagementComponent.prototype.callContainerFunction = function (f, arg) {
        if (this.container && this.container[f]) {
            arg ? this.container[f](arg) : this.container[f]();
        }
    };
    BidManagementComponent.prototype.configStompClient = function () {
        var _this = this;
        this._stompClient.beforeConnect = function () {
            var endpoint = _this._serviceUrl + "/bidding";
            var socket = new SockJS(endpoint);
            _this._stompClient.webSocketFactory = function () { return socket; };
        };
        this._stompClient.onConnect = function (receipt) {
            _this._loadTopBidByLotId$.pipe(operators_1.takeUntil(_this._destroy$)).subscribe(function (topBid) {
                _this.callContainerFunction('receiveBidHandler', topBid);
                _this.stompClientSubscribe();
                _this.connectedStatusChangeHandler(true);
            });
        };
        this._stompClient.onWebSocketClose = function (evt) {
            _this.connectedStatusChangeHandler(false);
        };
        this._stompClient.onWebSocketError = function (evt) {
            console.error(evt);
        };
    };
    BidManagementComponent.prototype.connectedStatusChangeHandler = function (isConnected) {
        if (this.connected !== isConnected) {
            this.connected = isConnected;
            this.onConnectionStatusChange.emit(this.connected);
        }
    };
    BidManagementComponent.prototype.stompClientSubscribe = function () {
        var _this = this;
        this._stompClient.subscribe("/lot/" + this.applicationId + "/" + this.lotId, function (lastBidFrame) {
            var lastBid = JSON.parse(lastBidFrame.body);
            _this.callContainerFunction('receiveBidHandler', lastBid);
        });
        this._stompClient.subscribe("/lot/" + this.applicationId + "/" + this.lotId + "/error-" + this.getWSSessionId(), function (lastBidFrame) {
            _this.callContainerFunction('onBiddingError', lastBidFrame.body);
        });
    };
    BidManagementComponent.prototype.getWSSessionId = function () {
        var sessionId = '';
        if (this._stompClient && this._stompClient.active) {
            var url = this._stompClient.webSocket['_transport']['url'];
            var urlSplit = url.split('/')[6].split('?');
            sessionId = urlSplit && urlSplit[0] ? urlSplit[0] : '';
        }
        return sessionId;
    };
    BidManagementComponent.prototype.sendBid = function () {
        if (this._stompClient && this._stompClient.active) {
            this._stompClient.publish({
                destination: "/bid/" + this.applicationId + "/" + this.lotId,
                body: JSON.stringify({
                    'amount': String(this.bidAmount)
                })
            });
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BidManagementComponent.prototype, "applicationId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], BidManagementComponent.prototype, "bidAmount", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], BidManagementComponent.prototype, "container", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], BidManagementComponent.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], BidManagementComponent.prototype, "lotId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], BidManagementComponent.prototype, "outputStompDebug", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], BidManagementComponent.prototype, "onConnectionStatusChange", void 0);
    BidManagementComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-bid-management',
            styles: [require('./bid-management.component.css')],
            template: require('./bid-management.component.html')
        }),
        __metadata("design:paramtypes", [bid_management_service_1.BidManagementService,
            idm_authentication_client_js_1.CookieService,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], BidManagementComponent);
    return BidManagementComponent;
}());
exports.BidManagementComponent = BidManagementComponent;
//# sourceMappingURL=bid-management.component.js.map